exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa-stack.small[data-v-a575ca12] { font-size: 0.666665em; width: 2.5em !important;\n}\n.fa-stack-1x.small[data-v-a575ca12] { font-size: 1.3em;\n}\n.warning-color[data-v-a575ca12] { color: #555;\n}\n", ""]);

// exports
